<template>
  <el-dialog
    top="0"
    class="dialog-full-min"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    append-to-body
    custom-class="operate-btn-dialog"
  >
    <div slot="title" class="flex flex-align-center">
      <i class="el-icon-warning" />
      <div class="margin-left-16">{{ textConfig.title }}</div>
    </div>
    <template v-if="showMessage">
      <div class="dialog__body" v-if="textConfig.slot">
        <slot :name="textConfig.slot" />
      </div>
      <div class="dialog__body" v-else>
        <div class="dialog__body-text" v-if="textConfig.isPass">
          {{ textConfig.messageTip }}
        </div>
        <div v-else>
          <div
            :class="[
              'refund_reason-text',
              textConfig.required ? 'required' : '',
            ]"
          >
            {{ textConfig.messageTip || "驳回原因" }}：
          </div>
          <div class="dialog-textarea">
            <el-input
              type="textarea"
              placeholder="请输入100字以内的内容"
              maxlength="100"
              v-model.trim="dataObj[params.cancelRemark]"
              show-word-limit
              :autosize="{ minRows: 6, maxRows: 10 }"
              @input="handlerValidator()"
            />
            <div v-if="isErrorShow" class="item-input__error">
              不能为空
            </div>
          </div>
        </div>
      </div>
      <div
        class="dialog-total"
        :class="{ 'is-pass': textConfig.isPass }"
        v-if="textConfig.isTotal"
      >
        <div>合计数量：{{ totalInfo.totalNum || "0" }}笔</div>
        <div v-if="isTotalAmount">
          合计金额：{{ totalInfo.totalAmount | toFenThousandsAndFloat }}元
        </div>
      </div>
      <div>
        <slot name="default"></slot>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()" :size="formSize">取消</el-button>
      <el-button
        type="primary"
        :size="formSize"
        @click="submit()"
        :loading="loading"
        v-if="showConfirmButton"
      >
        确认
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dataObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    textConfig: {
      type: Object,
      default: () => {
        return {
          title: '',
          messageTip: '',
          isPass: true,
          isBatch: false, // 是否批量
          isTotal: false, // 是否展示合并
          required: true, // 内容是否必填
        };
      },
    },
    // textConfig.isTotal = true展示的合并信息内容
    totalInfo: {
      type: Object,
      default: () => ({
        totalNum: 0, // 合计数量
        totalAmount: 0, // 合计金额
      }),
    },
    // 其他参数
    params: {
      type: Object,
      default: () => ({
        cancelRemark: 'cancelRemark',
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // 是否显示确认按钮
    showConfirmButton: {
      type: Boolean,
      default: true,
    },
    // 是否显示内容信息
    showMessage: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isTotalAmount() {
      return !!(this.totalInfo?.totalAmount || this.totalInfo?.totalAmount === 0);
    },
  },
  data() {
    return {
      isErrorShow: false,
    };
  },
  methods: {
    // 校验
    handlerValidator() {
      if (!this.dataObj[this.params.cancelRemark] && this.textConfig.required) {
        this.isErrorShow = true;
        return;
      }
      this.isErrorShow = false;
    },
    // 关闭
    handleClose() {
      this.isErrorShow = false;
      this.$emit('update:visible', false);
    },
    // 提交
    submit() {
      const params = JSON.parse(JSON.stringify(this.dataObj));
      if (params.operation === 2) {
        this.handlerValidator();
        if (this.isErrorShow) {
          return;
        }
      }
      this.$emit('submit', params);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .dialog__body {
    &-text {
      margin-left: 42px;
      line-height: 22px;
    }
  }
}
.operate-btn-dialog {
  ::v-deep {
    .el-button {
      min-width: 64px;
      padding: 8px 16px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
}
.item-input__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1.5;
  padding-top: 8px;
  text-align: right;
}
.refund_reason-text {
  word-break: keep-all;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4d4f51;
}
.required:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.dialog-textarea {
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
}
.is-pass {
  margin-left: 42px;
}
.dialog-total {
  line-height: 22px;
}
</style>
